import type { ReactElement } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import type { LaborCostChartData } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartData";
import { useTranslation } from "react-i18next";
import { LABOR_COST_CHART_COLORS } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/chart/ColorsPalette.ts";
import { useLaborCostChart } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/chart/useLaborCostChart.ts";
import "./LaborCostChart.scss";

interface Props {
  data: LaborCostChartData;
}

export default function LaborCostChart({ data }: Props): ReactElement {
  const { t } = useTranslation("common");
  const { slices, formatArcLabel, formatPct } = useLaborCostChart(data);

  if (slices.length === 0) return <div>{t("noResultsFound")}</div>;

  return (
    <div className="labor-cost-chart">
      <PieChart
        series={[
          {
            paddingAngle: data.slices.length > 1 ? 2 : 0,
            data: slices,
            highlightScope: { fade: "global", highlight: "none" },
            faded: { additionalRadius: -30, color: "gray" },
            arcLabel: (item): string => {
              return formatArcLabel(item.label, item.value);
            },
            valueFormatter: (item) => formatPct(item.value),
          },
        ]}
        colors={LABOR_COST_CHART_COLORS}
        slotProps={{
          legend: { hidden: slices.length > 8 },
        }}
      />
    </div>
  );
}
